import "../src/Assets/Styles/_app.scss";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Auth from "./Components/Routes/Auth";
import "bulma/css/bulma.min.css";
import "./Assets/Styles/CheckboxBlue.scss";
import ResetPassword from "./Components/Auth/ResetPassword";
import ResetPasswordVerify from "./Components/Auth/ResetPasswordToken";
import ChangePassword from "./Components/Auth/ChangePassword";
import "./Assets/Styles/feather.css";
import SetupWizard from "./Components/SetupWizard/SetupWizard";
import axios from "axios";
import { Config } from "./Config";
import Home from "../src/Components/Routes/Home/Home";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Just like any other React application, this is our main App component. Everything that is put
// inside the div with id="connexing-app" in the index.html file is rendered inside this component.
// this App components consistes of routes that are inside the application and are wrapped in a
// <Switch> component from react-router-dom in order to mathc the user's location with the related component.
// the route home itself is a similar component. All the routes after login are stored the same way
// inside the Routes directory in the related JS file.

function App() {
  const [TokenIsValid, setTokenIsValid] = useState(false);

  useEffect(() => {
    // In case there's already a JWT token in the localStorage that is valid,
    // this function handles the redirection
    checkPreviosLoginStatus();

    // Temporary value assigned to prevent logout right after logging in, the value will
    // be fetched and set after successful login.
    window.localStorage.setItem("TimeoutDuration", 500000);
  }, []);
  const checkPreviosLoginStatus = () => {
    let PreviousToken = window.localStorage.getItem("Token");

    if (PreviousToken !== null) {
      // making an API request to get the user's info whose token is stored in the localStorage
      let Req = {
        method: "GET",
        baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/profile",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
        },
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          setTokenIsValid(true);
        })
        .catch((Err) => {
          console.log(Err);
        });
    }
  };
  return (
    <React.Fragment>
      <BrowserRouter basename="/">
        <Switch>
          <Route path="/home" component={Home} />
          <Route path="/ResetPassword/:Token" component={ResetPasswordVerify} />
          <Route path="/ChangePassword/:Token" component={ChangePassword} />
          <Route path="/ResetPassword" exact component={ResetPassword} />
          <Route path="/SetupWizard" exact component={SetupWizard} />
          <Route path="/" exact component={Auth} />
          <Route path="/Redirect/:Token" component={Auth} />
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
